import BarsLoader from '@/shared-components/loaders/components/BarsLoader';

import './styles/ChannelButton.css';

export default function ChannelButton({ 
  children = "Chat",
  className = "",
  loading = false,
  success,
  successText,
  onClick = null,
  disabled = false, // When true, the button is disabled
  large = false,
  badgeCount = 0,
}) {

  // The button should be disabled if it's loading or if disabled is true.
  const isDisabled = loading || disabled;

  const handleClick = () => {
    if (!isDisabled && onClick) {
      onClick();
    }
  };

  const baseClass = [
    "channel-button__button",
    "element-non-selectable",
    className,
    large ? "channel-button__button--large" : "",
  ].filter(Boolean).join(" ");
  const numericBadgeCount = Number(badgeCount);
  const hasBadge = Number.isFinite(numericBadgeCount) && numericBadgeCount > 0;
  const badgeLabel = hasBadge ? (numericBadgeCount > 99 ? "99+" : String(Math.trunc(numericBadgeCount))) : null;

  if (success === true) {
    return (
      <button 
        className={baseClass}
        disabled
      >
        {successText}
        {hasBadge && <span className="channel-button__badge">{badgeLabel}</span>}
      </button>
    );
  }

  return (
    <button 
      className={baseClass}
      disabled={isDisabled}
      onClick={handleClick}
    >
      {loading && <BarsLoader className="channel-button__loader" />}
      <span>{children}</span>
      {hasBadge && <span className="channel-button__badge">{badgeLabel}</span>}
    </button>
  );
}
